module.exports = __webpack_public_path__ + "img/655fc2dd7fbfbe217296ace054ba7f12.png";